module.exports = __webpack_public_path__ + "img/fenghuokefu.bb90000a.png";